import { render } from "./department_report.vue?vue&type=template&id=6bc161d0"
import script from "./department_report.vue?vue&type=script&lang=js"
export * from "./department_report.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__